/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import {
  BaseQueryModel,
  IQueryModelOpts,
  useQuery,
  useGqlClient,
} from '@r-client/shared/data/client';
import {
  IGetUserReservationForEventQuery,
  IGetUserReservationForEventQueryVariables,
  GetUserReservationForEventDocument,
} from './types';
import { IEventsEvent } from '@r-client/data/graphql-types';
export type { IEventsEvent };

//export interface IGetUserReservationForEventQueryOpts extends Omit<IQueryModelOpts<IGetUserReservationForEventQueryVariables>, 'variables'> {
export interface IGetUserReservationForEventQueryOpts
  extends IQueryModelOpts<IGetUserReservationForEventQueryVariables> {
  variables: IGetUserReservationForEventQueryVariables;
}

export class GetUserReservationForEventQuery extends BaseQueryModel<
  IGetUserReservationForEventQuery,
  IGetUserReservationForEventQueryVariables
> {
  // This is fine. Here we explicitly change interface for query
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(opts: IGetUserReservationForEventQueryOpts) {
    super(opts);
  }

  get query() {
    return GetUserReservationForEventDocument;
  }
}
export function useGetUserReservationForEventQuery(
  opts: Omit<IGetUserReservationForEventQueryOpts, 'client'>
) {
  const client = useGqlClient();
  return useQuery(
    () => new GetUserReservationForEventQuery({ ...opts, client }),
    opts?.variables
  );
}
